"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferingScheduleHeaderDtoBuilder = void 0;
var offering_schedule_header_dto_1 = require("./offering-schedule-header.dto");
var moment = require("moment");
var date_time_1 = require("../../constants/date-time");
var OfferingScheduleHeaderDtoBuilder = /** @class */ (function () {
    function OfferingScheduleHeaderDtoBuilder() {
        this.now = moment();
        this.dateFormatInSchedule = new date_time_1.DateDefaultsConst().FULL_DATE;
        this.schedule = {
            startDate: this.now
                .clone()
                .add(20, 'days')
                .format(this.dateFormatInSchedule),
            endDate: this.now
                .clone()
                .add(100, 'days')
                .format(this.dateFormatInSchedule),
            durationInMinutes: 65,
            isDurationVaries: false,
            days: [offering_schedule_header_dto_1.WeekDay.MONDAY, offering_schedule_header_dto_1.WeekDay.THURSDAY],
        };
    }
    OfferingScheduleHeaderDtoBuilder.prototype.withStartDate = function (startDate) {
        this.schedule.startDate = startDate;
        return this;
    };
    OfferingScheduleHeaderDtoBuilder.prototype.withEndDate = function (endDate) {
        this.schedule.endDate = endDate;
        return this;
    };
    OfferingScheduleHeaderDtoBuilder.prototype.withDurationInMinutes = function (durationInMinutes) {
        this.schedule.durationInMinutes = durationInMinutes;
        return this;
    };
    OfferingScheduleHeaderDtoBuilder.prototype.withDays = function (days) {
        this.schedule.days = days;
        return this;
    };
    OfferingScheduleHeaderDtoBuilder.prototype.withDurationVaries = function (isDurationVaries) {
        this.schedule.isDurationVaries = isDurationVaries;
        return this;
    };
    OfferingScheduleHeaderDtoBuilder.prototype.withDurationText = function (durationText) {
        this.schedule.durationText = durationText;
        return this;
    };
    OfferingScheduleHeaderDtoBuilder.prototype.withDaysDetails = function (daysDetails) {
        this.schedule.daysDetails = daysDetails;
        return this;
    };
    OfferingScheduleHeaderDtoBuilder.prototype.build = function () {
        return this.schedule;
    };
    return OfferingScheduleHeaderDtoBuilder;
}());
exports.OfferingScheduleHeaderDtoBuilder = OfferingScheduleHeaderDtoBuilder;
//# sourceMappingURL=offering-schedule-header.dto.builder.js.map